import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Form, FormText } from 'react-bootstrap';
import VerbSelect from '../inputs/VerbSelect';
import WithTranslation from '../../../hocs/WithTranslation';

class BasicSelect extends Component {
    static propTypes = {
        groupClass: PropTypes.string,
        className: PropTypes.string,
        input: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        options: PropTypes.array,
        loadOptions: PropTypes.func,
        disabled: PropTypes.bool,
        displayHelp: PropTypes.bool,
        inputClassName: PropTypes.string,
        styleProps: PropTypes.object,
        description: PropTypes.string,
        icon: PropTypes.string,
        labelKey: PropTypes.string,
        valueKey: PropTypes.string,
        isMulti: PropTypes.bool,
        clearValue: PropTypes.string,
    };

    getGroupClassName = () => {
        const { required, className, icon } = this.props;
        return cns(className, {
            required,
            hasIcon: icon
        });
    };

    getFeedbackMessage = () => {
        const { touched, error, warning, valid, initial } = this.props.meta;
        const { value } = this.props.input;

        let message = '';
        if (touched) {
            if (error) {
                message = error;
            } else if (warning) {
                message = warning;
            }
        }

        if (value && value !== initial && !valid && error) {
            message = error;
        }
        return message;
    };

    getValidationState = () => {
        const { touched, error, warning } = this.props.meta;
        if (touched && error) {
            return 'error';
        }
        if (touched && warning) {
            return 'warning';
        }
        return null;
    };

    handleChange = (value = {}, changeEvent) => {
        const { input = {}, isMulti = false, valueKey = 'value', clearValue = '' } = this.props;

        if (changeEvent.action === 'clear') {
            return input.onChange(clearValue, changeEvent);
        }
        return input.onChange(typeof value === 'string' || isMulti ? value : value[valueKey], changeEvent);
    };

    render() {
        const {
            label,
            description,
            input = {},
            placeholder,
            options,
            required = false,
            disabled = false,
            displayHelp = true,
            inputClassName = '',
            styleProps = {},
            labelKey = 'label',
            valueKey = 'value'
        } = this.props;
        const { horizontal = false, inputStyle = {} } = styleProps;
        let labelSection;
        if (label || description) {
            labelSection = (
                <div className={horizontal ? 'col-12 col-sm-6 no-padding' : ''}>
                    <div className={horizontal ? 'col-12 col-sm-10 no-padding' : ''}>
                        <label htmlFor={input.name} className={horizontal ? 'form-label' : ''}>
                            {label}
                            {required && <span className={'required-tag'}>*</span>}
                        </label>
                        <p className={horizontal ? 'form-description' : ''}> {description} </p>
                    </div>
                </div>
            );
        }

        let helpBlockSection = null;
        if (displayHelp) {
            helpBlockSection = <FormText>{this.getFeedbackMessage()}</FormText>;
        }

        return (
            <Form.Group className={this.getGroupClassName()} validated={this.getValidationState()}>
                {labelSection}
                <VerbSelect
                    {...this.props}
                    {...input}
                    onChange={this.handleChange}
                    onBlur={(value) => input.onBlur(value)}
                    className={cns('basic-select', inputStyle)}
                    labelKey={labelKey}
                    valueKey={valueKey}
                    disabled={disabled}
                    options={options}
                    placeholder={placeholder}
                    styleProps={cns(inputClassName)}
                    helpBlockSection={helpBlockSection}
                />
            </Form.Group>
        );
    }
}

export default WithTranslation(BasicSelect);
